import { uploadDemoGraphicConstants } from '../../_constants/uploadDemographic.constants'
import { UploadDemographicService } from '../../_services/UploadDemographicService.service';


export const UploadDemographicDataAction = {
    uploadCsvAction: function (data) {
        return dispatch => {
            dispatch(request());
            UploadDemographicService.uploadCsvService(data)
                .then(
                    UploadDemographicData => {
                        
                        dispatch(success(UploadDemographicData));
                    },
                    error => {
                        dispatch(failure(error));
                    }
                );
        };
    
        function request() { return { type: uploadDemoGraphicConstants.REQUEST_UPLOAD_CSV} }
        function success(UploadDemographicData) { return { type: uploadDemoGraphicConstants.RECIEVE_UPLOAD_CSV, UploadDemographicData: UploadDemographicData } }
        function failure(error) { return { type: uploadDemoGraphicConstants.ERROR_UPLOAD_CSV, error } }
    }
}


// WEBPACK FOOTER //
// ./src/_actions/UploadDemoGraphicData/UploadDemographicData.action.js